import {IEnvironment} from '../app/application/data-types'

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://api-bo-test.internal.sparbankensyd.se/api',
  rtUrl: 'https://api-rt-test.internal.sparbankensyd.se/api',
  nextGeneration: true,
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  domain: 'bo.internal.sparbankensyd.se',
  testMode: true,
  developerMode: false
}

